// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"726e8433","239":"7ca2c224","453":"a376ded4","732":"d413c10e"}[chunkId] + ".chunk.js";
};